import React from 'react'
import styles from './contributor-list.module.css'
import ContributorPreview from './ContributorPreview'

function ContributorList (props) {
  const {contributors} = props
  const teamMembers = contributors.filter(contributor => (
    contributor.roles.includes('teammember')
  ))
  const contributorsWithoutTeamMembers = contributors.filter(contributor => (!contributor.roles.includes('teammember')))
  return (
    <div>
      <h2>Flyt-Frem-teamet</h2>
      <div className={styles.grid}>
        {teamMembers.map(contributor => (
          <ContributorPreview
            key={contributor._id}
            name={contributor.name}
            bio={contributor._rawBio}
            roles={contributor.roles}
            image={contributor._rawImage}
            slug={contributor.slug && contributor.slug.current}
          />
        ))}
      </div>
      <h2>Bidragsytere</h2>
      <div className={styles.grid}>
        {contributorsWithoutTeamMembers.map(contributor => (
          <ContributorPreview
            key={contributor._id}
            name={contributor.name}
            bio={contributor._rawBio}
            roles={contributor.roles}
            image={contributor._rawImage}
            slug={contributor.slug && contributor.slug.current}
          />
        ))}
      </div>
    </div>
  )
}

export default ContributorList
